import axios from 'axios'
import { ElMessage } from 'element-plus'
const service = axios.create({
    baseURL: "https://fishair.org/api/",
    // baseURL: "http://localhost:8000/",
    timeout: 100000*1000
})
service.interceptors.request.use(config => {
    config.data = JSON.stringify(config.data);
    // config.responseType = "arraybuffer" | "blob" | "document" | "json" | "text" | "stream"
    config.headers = {
        'Content-Type': 'application/json;application/octet-stream;application/x-zip-compressed'
    }
    // const token = getCookie('name')
    //if(token){
        //config.params = {'token':token}
        //config.headers.token = token;
    // }
    return config
}, error=>{
    Promise.reject(error)
})

service.interceptors.response.use(response =>{
    return response
},error => {
    if(error && error.response) {
        switch (error.response.status) {
            case 400:
                error.message = 'wrong request'
                break;
            case 401:
                error.message = 'No Authorization'
                break;
            case 422:
                error.message = 'Parameters wrong'
                break;
            case 500:
                error.message = 'Server Error'
                break;
            default:
                error.message = `Connection error: ${error.response.status}`
        }
    } else{
        if (JSON.stringify(error).includes('timeout')){
            ElMessage.error('Connection Time out, please refresh current page.')
        }
        error.message = 'Connected failed'
    }
    ElMessage.error(error.message)
    return Promise.resolve(error.response)

})
export default  service